
import React from "react";
import { Segment } from "semantic-ui-react";
import { FormCategoryIcon } from "../../formType/FormCategoryIcon";
import { useApplicationConfiguration } from "../../../configuration/ConfigurationContext";
import { useTranslation } from "react-i18next";
import { EAuditStatus } from "../../../interfaces/IAudit";
import { Link } from "react-router-dom";
import { PersonNameById } from "../../../../sg-hpr/components/persons/PersonName";
import { AuditStatusLabel } from "../audit/AuditStatusLabel";
import { makeAuditPageHref, makeEditAuditPageHref } from "../../../utils/auditoinnit.helpers";
import { IAuditItem } from "../../../interfaces/IAuditItem";
import { EvaluationsSummary } from "../../form/EvaluationsSummary/EvaluationsSummary";
import { RenderFormType } from "../../formType/RenderFormType";

export interface AuditListItemProps {
    item: IAuditItem;
}

export const AuditListItem: React.FC<AuditListItemProps> = ({ item, }) => {
    const { t } = useTranslation();
    const { components: { LocationName } } = useApplicationConfiguration()

    const auditHref = makeAuditPageHref(item.guid);
    const editAuditHref = makeEditAuditPageHref(item.guid, false, true);

    const texts = {
        informer: t("Ilmoittaja"),
        unnamed: t("Nimetön")
    };

    return (
        <Segment
            vertical
            padded
            className="AuditListItem-segment"
            disabled={item.removed}
        >


            {/* Heading */}
            <Link
                to={item.status === EAuditStatus.Draft ? editAuditHref : auditHref}
                className="AuditListItem-heading"
            >

                <div className="heading-row">
                    <div style={{ marginRight: "10px" }}>
                        <RenderFormType formTypeId={item.formType}
                            render={({ formType }) => (
                                <FormCategoryIcon categoryId={formType.category} color="green" />
                            )}
                        />
                    </div>
                    <div>
                        <h5 className="ui header" style={{ marginBottom: 0 }}> {item.title || texts.unnamed} <span className="subtle-text">#{item.id}</span></h5>
                    </div>
                </div>
                <AuditStatusLabel as="small" className="AuditListItem-status" status={item.status} />
            </Link>

            {/* Meta  */}
            <div className="AuditListItem-meta">
                {item.target ? <div className="meta-item" title={texts.informer}> <LocationName locationId={item.target} /></div> : null}
                <div className="meta-item">
                    {item.submitter && <PersonNameById personId={item.submitter} />}
                </div>
                {item.statics ? (
                    <EvaluationsSummary data={item.statics} />
                ) : null}
            </div>

        </Segment>
    );
};


